import React, { Component, Fragment } from "react";
import "./home.css";
import { Tabs, List, Row, Col, Card } from "antd";
import "antd/dist/antd.css";
import gameImage from "../../style/images/home/test image.png";
import buttonimage from "../../style/images/home/enter-btn.png";
import medal from "../../style/images/achevements btn.png";

import GilroyLight from "../../style/fonts/Gilroy-Light.otf";
const TabPane = Tabs.TabPane;

export default class GameTab extends Component {
  render() {
    const imageClick = () => {
      console.log("Click");
    };
    return (
      <Fragment>
        <Card>
          <div className="row">
            <div className="col-md-1" />
            <div
              className="col-md-5 "
              style={{ marginTop: "5%", marginBottom: "5%" }}
            >
              <div className="row">
                <div className="row">
                  <div className="col-sm-8">
                    <h2 className="title">Snake - T 18</h2>
                  </div>
                  <div className="col-sm-4" />
                </div>

                <div className="col-md-8 col-sm-8 col-xs-7" style={{ textAlign: "left" }}>
                  <p className="p">
                    <b>STARTS</b>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    01/01/2001
                  </p>
                  <p className="p">
                    <b>LEVEL REQUIRED</b> &nbsp;&nbsp; LV. 23
                  </p>
                  <p
                    className="p"
                    style={{ color: "white", fontSize: "large" }}
                  >
                    <b>CASH PRIZE</b> &nbsp;&nbsp; &nbsp;&nbsp;160000
                  </p>
                </div>

                <div className="col-xs-5 col-sm-4 col-md-4 ">
                  <div className="playerbox">
                    <p style={{ fontSize: "xx-large", margin: "0" }}>
                      <b>25</b>
                    </p>
                    <p>
                      PLAYERS <br />
                      REQUIRED
                    </p>
                  </div>
                </div>
                {/* adding game tab */}
                <div className="row">
                  <div className="col-xs-10 col-sm-6 col-md-8 gamebar">
                    <div className="row">
                      <div className="col-xs-2">
                        <img src={medal} />
                      </div>
                      <div className="col-xs-5" style={{ padding: "3%" }}>
                        <p className="pi">1200 POINTS</p>
                      </div>
                      <div className="col-xs-5">
                        <p className="pi">
                          2:480 points <br /> 3:200 points
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* adding buttom */}
                <br />
                <div className="row">
                  <div className="col-xs-7" />
                  <div
                    className="col-xs-4 enterbutton"
                
                  >
                    <img
                      style={{ width: "80%" }}
                      className="buttonImage"
                      src={buttonimage}
                      onClick={() => imageClick()}
                    />
                  </div>
                  <div className="col-xs-1" />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <img className="gameImage" src={gameImage} />
            </div>
          </div>
        </Card>
      </Fragment>
    );
  }
}
